export default async (store, action) => {
  // store.dispatch({
  //   type: ADD_QUERY_DATA_SUCCESS,
  //   [pendingTask]: end
  // });
};
